export default __webpack_public_path__ + "assets/icons/icon-search.15a27b9cacf5adfc262772d6787533a4.svg";